var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import { MixpanelEvents } from "../mixpanel/events";
import MPStorage from "@/services/LocalStorage";
function useLocalStorage(key, initialValue) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    var _a = __read(React.useState(function () {
        try {
            // Get from local storage by key
            var item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            // If error also return initialValue
            return initialValue;
        }
    }), 2), storedValue = _a[0], setStoredValue = _a[1];
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    var setValue = function (value) {
        try {
            // Allow value to be a function so we have same API as useState
            var valueToStore = value instanceof Function ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);
            // Save to local storage
            MPStorage.saveToLocalStorage(key, JSON.stringify(valueToStore));
        }
        catch (error) {
            // A more advanced implementation would handle the error case
            // console.log(error);
            MixpanelEvents.errorEvent("Error with setValue in useLocalStore", {
                payload: error,
            });
        }
    };
    var getValue = function () {
        try {
            // Get from local storage by key
            var item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            // If error also return initialValue
            return initialValue;
        }
    };
    return {
        storedValue: storedValue,
        setValue: setValue,
        getValue: getValue,
    };
}
export default useLocalStorage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlTG9jYWxTdG9yZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInVzZUxvY2FsU3RvcmUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEtBQUssS0FBSyxNQUFNLE9BQU8sQ0FBQztBQUMvQixPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0sb0JBQW9CLENBQUM7QUFDcEQsT0FBTyxTQUFTLE1BQU0seUJBQXlCLENBQUM7QUFFaEQsU0FBUyxlQUFlLENBQUksR0FBVyxFQUFFLFlBQWU7SUFDdEQsMkJBQTJCO0lBQzNCLHlFQUF5RTtJQUNuRSxJQUFBLEtBQUEsT0FBZ0MsS0FBSyxDQUFDLFFBQVEsQ0FBSTtRQUN0RCxJQUFJO1lBQ0YsZ0NBQWdDO1lBQ2hDLElBQU0sSUFBSSxHQUFHLE1BQU0sQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1lBQzlDLG1EQUFtRDtZQUNuRCxPQUFPLElBQUksQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsWUFBWSxDQUFDO1NBQy9DO1FBQUMsT0FBTyxLQUFLLEVBQUU7WUFDZCxvQ0FBb0M7WUFDcEMsT0FBTyxZQUFZLENBQUM7U0FDckI7SUFDSCxDQUFDLENBQUMsSUFBQSxFQVZLLFdBQVcsUUFBQSxFQUFFLGNBQWMsUUFVaEMsQ0FBQztJQUVILGtFQUFrRTtJQUNsRSw4Q0FBOEM7SUFDOUMsSUFBTSxRQUFRLEdBQUcsVUFBQyxLQUFRO1FBQ3hCLElBQUk7WUFDRiwrREFBK0Q7WUFDL0QsSUFBTSxZQUFZLEdBQ2hCLEtBQUssWUFBWSxRQUFRLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDO1lBQ3pELGFBQWE7WUFDYixjQUFjLENBQUMsWUFBWSxDQUFDLENBQUM7WUFDN0Isd0JBQXdCO1lBQ3hCLFNBQVMsQ0FBQyxrQkFBa0IsQ0FBQyxHQUFVLEVBQUUsSUFBSSxDQUFDLFNBQVMsQ0FBQyxZQUFZLENBQUMsQ0FBQyxDQUFDO1NBQ3hFO1FBQUMsT0FBTyxLQUFLLEVBQUU7WUFDZCw2REFBNkQ7WUFDN0Qsc0JBQXNCO1lBQ3RCLGNBQWMsQ0FBQyxVQUFVLENBQUMsc0NBQXNDLEVBQUU7Z0JBQ2hFLE9BQU8sRUFBRSxLQUFLO2FBQ2YsQ0FBQyxDQUFDO1NBQ0o7SUFDSCxDQUFDLENBQUM7SUFFRixJQUFNLFFBQVEsR0FBRztRQUNmLElBQUk7WUFDRixnQ0FBZ0M7WUFDaEMsSUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLFlBQVksQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUM7WUFDOUMsbURBQW1EO1lBQ25ELE9BQU8sSUFBSSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxZQUFZLENBQUM7U0FDL0M7UUFBQyxPQUFPLEtBQUssRUFBRTtZQUNkLG9DQUFvQztZQUNwQyxPQUFPLFlBQVksQ0FBQztTQUNyQjtJQUNILENBQUMsQ0FBQztJQUVGLE9BQU87UUFDTCxXQUFXLGFBQUE7UUFDWCxRQUFRLFVBQUE7UUFDUixRQUFRLFVBQUE7S0FDVCxDQUFDO0FBQ0osQ0FBQztBQUVELGVBQWUsZUFBZSxDQUFDIn0=